import axios from "axios";
import { base_url } from "./Blogs";
const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
const RAZORPAY_SECRET = process.env.REACT_APP_RAZORPAY_SECRET;
// const RAZORPAY_API_URL = "https://api.razorpay.com/v1/orders";
const RAZORPAY_BASE_URL = "https://api.razorpay.com/v1";
// UNCOMMENT IT WHEN RUNNING ON LOCALHOST
// const PROXY_URL = "https://cors-anywhere.herokuapp.com/";

async function createOrder(amount, currency = "INR") {
  try {
    const response = await axios.post(
      `${RAZORPAY_BASE_URL}/orders`,
      {
        amount: amount,
        currency: currency,
        payment_capture: 1, // Auto capture payment
      },
      {
        auth: {
          username: RAZORPAY_KEY_ID,
          password: RAZORPAY_SECRET,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating Razorpay order:", error);
    throw error;
  }
}

export const sendTransactionData = async (paymentDetails, userId) => {
  console.log("Transaction Data:", paymentDetails, userId);
  try {
    const payload = {
      paymentId: paymentDetails.razorpay_payment_id || "",
      orderId: paymentDetails.razorpay_order_id || "",
      signature: paymentDetails.razorpay_signature || "",
      userId: userId,
      source: "LNC",
      paymentStatus: "success",
    };

    const response = await fetch(`${base_url}/core/predictions/transactions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (response.status === 200) {
      // console.log("Transaction processed successfully.");
      return true; // Return true if transaction was successful
    }
    if (!response.ok) {
      throw new Error("Failed to process transaction.");
    }

    return false; // Return false if transaction failed
  } catch (error) {
    console.error("Transaction API Error:", error);
    throw error; // Re-throw error for handling in calling function
  }
};
export const verifyPayment = async (paymentId) => {
  try {
    const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
    const RAZORPAY_SECRET = process.env.REACT_APP_RAZORPAY_SECRET;

    const response = await fetch(
      `${RAZORPAY_BASE_URL}/payments/${paymentId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Basic ${btoa(
            `${RAZORPAY_KEY_ID}:${RAZORPAY_SECRET}`
          )}`,
        },
      }
    );

    if (response.status === 200) {
      return true; // Payment verified
    } else {
      const data = await response.json();
      console.error("Payment verification failed:", data);
      return false;
    }
  } catch (error) {
    console.error("Error verifying payment:", error);
    return false;
  }
};

export const paymentAmount = 1;
export { createOrder };
